/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityItemDto } from '../../models/activity-item-dto';

export interface VolunteerStatsControllerGetActivityFeed$Params {
  limit: number;
}

export function volunteerStatsControllerGetActivityFeed(http: HttpClient, rootUrl: string, params: VolunteerStatsControllerGetActivityFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityItemDto>>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsControllerGetActivityFeed.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityItemDto>>;
    })
  );
}

volunteerStatsControllerGetActivityFeed.PATH = '/volunteer-stats/activity-feed';
